var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2081_38355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9915 8.99964C17.9915 13.9657 13.9657 17.9915 8.99964 17.9915C4.03359 17.9915 0.0078125 13.9657 0.0078125 8.99964C0.0078125 4.03359 4.03359 0.0078125 8.99964 0.0078125C13.9657 0.0078125 17.9915 4.03359 17.9915 8.99964ZM1.64827 8.99964C1.64827 13.0597 4.93959 16.351 8.99964 16.351C13.0597 16.351 16.351 13.0597 16.351 8.99964C16.351 4.93959 13.0597 1.64827 8.99964 1.64827C4.93959 1.64827 1.64827 4.93959 1.64827 8.99964Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99908 3.27832C8.54761 3.27832 8.18164 3.6443 8.18164 4.09576V9.38189C8.18164 9.38189 8.18164 9.595 8.28521 9.7553C8.35453 9.89124 8.46259 10.0094 8.60458 10.0913L12.381 12.2717C12.772 12.4974 13.2719 12.3634 13.4976 11.9724C13.7233 11.5815 13.5894 11.0815 13.1984 10.8558L9.81652 8.90328V4.09576C9.81652 3.6443 9.45055 3.27832 8.99908 3.27832Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2081_38355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSvgrepoCom1);
export default __webpack_public_path__ + "static/media/time-svgrepo-com 1.cb044bd92d324550da90f655db33d3bb.svg";
export { ForwardRef as ReactComponent };